import { supabase } from "@/integrations/supabase/client";

type EventType = "click" | "view" | "pageview";
type EventCategory = "News" | "Publication" | "Whatsapp" | "Email" | "Service" | "Page" | "Contact" | "Address";

interface TrackEventParams {
  eventType: EventType;
  eventCategory: EventCategory;
  eventLabel?: string;
}

export const trackEvent = async ({ eventType, eventCategory, eventLabel }: TrackEventParams) => {
  try {
    await supabase.from("analytics_events").insert({
      event_type: eventType,
      event_category: eventCategory,
      event_label: eventLabel || null,
    });
  } catch (error) {
    // Silently fail - analytics should not break the user experience
    console.debug("Analytics tracking error:", error);
  }
};

// Convenience functions
export const trackClick = (category: EventCategory, label?: string) => 
  trackEvent({ eventType: "click", eventCategory: category, eventLabel: label });

export const trackView = (category: EventCategory, label?: string) => 
  trackEvent({ eventType: "view", eventCategory: category, eventLabel: label });

export const trackPageView = (pageName: string) => 
  trackEvent({ eventType: "pageview", eventCategory: "Page", eventLabel: pageName });
